import { Button, Card, Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import PageHeading from "../../../../../components/common/PageHeading";
import RightBar from "../../../../../components/common/RightBar";
import { paymentBatchesData } from "../../../../../data/accounting";

import "./PaymentsBatch.css";

const PaymentsBatchRightBar = [];

function PaymentsBatch() {
  const [paymentsBatch, setPaymentsBatch] = useState({});

  const { id } = useParams();

  useEffect(() => {
    const newObject = paymentBatchesData.find((item) => {
      return item.id === Number(id);
    });
    console.log(newObject);
    setPaymentsBatch(newObject);
  }, [paymentsBatch]);

  console.log(paymentsBatch?.payments);

  return (
    <>
    <div className="payments-batch">
      <PageHeading heading="Payments Batch" />
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Form colon={false} labelCol={{ span: 8 }}>
            <Row>
              <Col span={12}>
                <Form.Item label="Total Amount">
                  <span>${paymentsBatch?.totalAmount}</span>
                </Form.Item>
                <Form.Item label="Number of payments">
                  <span>{paymentsBatch?.numberOfPayments}</span>
                </Form.Item>
                <Form.Item label="Status">
                  <span>{paymentsBatch?.status}</span>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Prepared By">
                  <span>{paymentsBatch?.preparedBy}</span>
                </Form.Item>
                <Form.Item label="Prepared On">
                  <span>{paymentsBatch?.preparedOn}</span>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col span={24}>
          <Card title="Rental Income Account">
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <strong>
                  {paymentsBatch?.checkType} Check for {paymentsBatch?.checkFor}
                  : {paymentsBatch?.company}
                </strong>
              </Col>
              <Col span={24}>
                <Row className="header-row">
                  <Col span={10}>
                    <span>Property</span>
                  </Col>
                  <Col span={2}>
                    <span>Unit</span>
                  </Col>
                  <Col span={2}>
                    <span>GL Account</span>
                  </Col>
                  <Col span={4}>
                    <span>Description</span>
                  </Col>
                  <Col span={2}>
                    <span>Due Date</span>
                  </Col>
                  <Col span={2}>
                    <span>Bill Amount</span>
                  </Col>
                  <Col span={2}>
                    <span>Payment</span>
                  </Col>
                </Row>
                {paymentsBatch?.payments
                  ? paymentsBatch.payments.map((item, index) => {
                      return (
                        <Row className="data-row" key={index}>
                          <Col span={10}>
                            <span>{item.property}</span>
                          </Col>
                          <Col span={2}>
                            <span>{item.unit}</span>
                          </Col>
                          <Col span={2}>
                            <span>{item.glAccount}</span>
                          </Col>
                          <Col span={4}>
                            <span>{item.description}</span>
                          </Col>
                          <Col span={2}>
                            <span>{item.dueDate}</span>
                          </Col>
                          <Col span={2}>
                            <span className="onclick-text">
                              ${item.billAmount}
                            </span>
                          </Col>
                          <Col span={2}>
                            <span>${item.payment}</span>
                          </Col>
                        </Row>
                      );
                    })
                  : null}
              </Col>
              <Col span={24}>
                <Row justify="end">
                  <Col>
                    <strong>Total {paymentsBatch?.totalAmount}</strong>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={24}>
          <Row align="middle" gutter={[8, 0]}>
            <Col>
              <Button type="primary">Approve and Send Payments</Button>
            </Col>
            <Col>
              <span className="red-onclick-text">Reject All Payments</span>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
    <div className="RightSidebar">
      <RightBar RightBarData={PaymentsBatchRightBar} />
    </div>
    </>
  );
}

export default PaymentsBatch;
